<template>
    <div :class="getClasses()"  @click="activateField" v-if="showField()">
        <div class="field-label" v-show="showLabel">{{ customField.label }}</div>

        <div class="text-field-wrap" v-if="customField.field_type == 'requisition_number'">
            <div class="text-field">
                <span class="exclude-outside-click edit-d-title" v-show="!editing">#{{ customField.value }}</span>
                <div class="input-group" v-show="editing" v-click-outside="outside" >
                    <div class="input-group-prepend">
                        <span class="input-group-text">#</span>
                    </div>
                    <input class="form-control" v-model="customField.value" :placeholder="customField.label" ref="customInput" @keyup.enter="editing = false" @change="updateCustomField(customField)" @blur="editing = false" />
                </div>
            </div>
        </div>

        <div class="text-field-wrap" v-if="customField.field_type == 'currency'">
            <div class="currency-field">
                <span class="exclude-outside-click edit-d-title" v-show="!editing">${{ customField.value ? formatPrice(customField.value) : '0.00' }}</span>
                <div class="input-group" v-show="editing" v-click-outside="outside">
                    <div class="input-group-prepend">
                        <span class="input-group-text">$</span>
                    </div>
                    <input class="form-control" v-model="customField.value" :placeholder="customField.label" ref="customInput" @keyup.enter="editing = false" @change="updateCustomField(customField)" @blur="editing = false" />
                </div>
            </div>
        </div>

        <div class="text-field-wrap" v-if="customField.field_type == 'text'">
            <div class="text-field">
            <span class="exclude-outside-click edit-d-title" v-show="!editing">{{ customField.value ? customField.value : 'N/A' }}</span>
            <input @keyup.enter="editing = false" @blur="editing = false" ref="customInput" v-show="editing" v-click-outside="outside" :placeholder="customField.label" @change="updateCustomField(customField)" type="text" class="form-control" v-model="customField.value"/>
            </div>
        </div>

        <div class="field-wrap" v-if="customField.field_type == 'wysiwyg'">
            <ckeditor
            editorUrl="/js/ckeditor/ckeditor.js"
            ref="customInput"
            v-model="customField.value"
            :id="'custom-field'"
            :config="editorConfig"
            @input="changed=true"
            @blur="checkChangedFieldValue(customField)"
            @ready="changed=false"
            ></ckeditor>
        </div>

        <!-- Engagement Manager -->
            <div class="field-wrap coordinator-field" @click="showEngagementManager" v-if="customField.field_name == 'engagement_manager'">
                <div class="info-bubbles cursor-pointer exclude-outside-click">
                	<template v-if="engagementManager">
                <span 
                    v-if="engagementManager.id" 
                    :title="engagementManager.name" 
                    v-b-tooltip.hover.html 
                    class="initials badge badge-primary exclude-outside-click project-coordinator"
                >{{(engagementManager.name) | textInitials}}</span>
            	</template>
            	<template v-else>
            		<span class="initials  exclude-outside-click">None</span>
            	</template>
                <plus-button v-show="!editing" class="tagged-tags"/>
                </div>
                <div class="custom-field">
                    <multiselect
                        ref="engagementManager"
                        v-model="engagementManager"
                        v-click-outside="outside"
                        v-show="editing"
                        label="name"
                        track-by="id"
                        :option-height="42"
                        :options="allActiveUsers"
                        :show-labels="false"
                        :multiple="false"
                        :allow-empty="false"
                        :searchable="true"
                        @close="editing = false"
                        @input="changeEngagementManager()"
                    ></multiselect>
                </div>
            </div>

            <!-- Project Lead -->
            <div class="field-wrap coordinator-field" @click="showProjectLead" v-if="customField.field_name == 'project_lead'">
                <div class="info-bubbles cursor-pointer exclude-outside-click">
                	<template v-if="projectLead">
                <span 
                    v-if="projectLead.id" 
                    :title="projectLead.name" 
                    v-b-tooltip.hover.html 
                    class="initials badge badge-primary exclude-outside-click project-coordinator"
                >{{(projectLead.name) | textInitials}}</span>
            	</template>
            	<template v-else>
            		<span>None</span>
            	</template>
                <plus-button v-show="!editing" class="tagged-tags"/>
                </div>
                <div class="custom-field">
                    <multiselect
                        ref="projectLead"
                        v-model="projectLead"
                        v-click-outside="outside"
                        v-show="editing"
                        label="name"
                        track-by="id"
                        :option-height="42"
                        :options="allActiveUsers"
                        :show-labels="false"
                        :multiple="false"
                        :allow-empty="false"
                        :searchable="true"
                        @close="editing = false"
                        @input="changeProjectLead()"
                    ></multiselect>
                </div>
            </div>

        
        <div class="color-picker-field-wrap" v-if="customField.field_type == 'color_picker'">
            <div class="text-field">
                <span class="exclude-outside-click" v-show="!editing" style="border-radius: 10px;" :style="{background: customField.value ? customField.value : 'transparent', color: customField.value ? '#fff' : '#4C9850', padding: customField.value ? '5px 10px' : '5px 0'}">{{ customField.value ? customField.value : 'N/A' }}</span>
                <twitter-picker v-show="editing" v-click-outside="outside" @input="updateColor" v-model="color" />
            </div>
        </div>

        <!-- Status --> 
        <div class="field-wrap no-icon" v-if="customField.field_type == 'status'">
            <span
                v-if="customField.value"
                class="exclude-outside-click field-value status-field-value"
                :style="{ backgroundColor: parseValue(customField.value).color || customField.value.color }"

            >{{ parseValue(customField.value).name || customField.value.name }}</span>
            <span
                v-if="!customField.value"
                class="exclude-outside-click field-value"
                v-show="!editing"
            >Click to set...</span>
            <div class="custom-field status-field">
                <div class="custom-field-outside-bg-mobile" v-show="editing"></div>
                <multiselect
                ref="customInput"
                :searchable="false"
                v-show="editing"
                v-field-dismiss="outside"
                v-model="customField.value"
                :options="getOptions"
                @close="editing=false"
                @input="updateCustomField(customField);"
                @select="editing=false"
                :custom-label="customLabel"
                :show-labels="false">
                <template slot="option" slot-scope="props">
                    <div :style="{ color: '#fff', borderRadius: '10px', backgroundColor: props.option.color, height: '40px', lineHeight: '40px', textAlign: 'center' }">{{ props.option.name }}</div>
                </template>
                </multiselect>
            </div>
        </div>

        <div class="field-wrap" v-if="customField.field_type == 'textarea'">
            <span
                class="exclude-outside-click field-value text-hover-bg"
                v-show="!editing"  :title="customField.value"
                v-b-tooltip.hover
            >{{ customField.value || 'Click to set...' }}</span>
            <div class="custom-field">
                <textarea
                :rows="rows"
                ref="customInput"
                class="form-control custom-inputs"
                v-show="editing"
                v-click-outside="outside"
                @change="updateCustomField(customField)"
                @blur="editing = false"
                v-model="customField.value"
                ></textarea>
            </div>
        </div>

    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Twitter } from 'vue-color';

export default {
    components: {
        'twitter-picker': Twitter,
    },
    props: {
        customField:Object,
        showLabel: {
            type:Boolean,
            default: true
        },
        detail:Object,
        rows: {
            type:Number,
            default: 10
        },
    },
    data() {
        return {
            editing: false,
            projectLead: {},
            engagementManager: {},
            color: '#000',
            changed:false,

            // wysiwyg
            editorConfig: {
                toolbar:  [
                { name: 'document', groups: [ 'mode' ], items: [ 'Source' ] },
                { name: 'clipboard', groups: [ 'clipboard', 'undo' ], items: [ 'Cut', 'Copy', 'Paste', 'PasteText', '-', 'Undo', 'Redo' ] },                                        
                { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ], items: [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ] },
                { name: 'paragraph', groups: [ 'list', 'blocks', 'align' ], items: [ 'NumberedList', 'BulletedList', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock' ] },
                { name: 'links', items: [ 'Link', 'Unlink' ] },
                { name: 'insert', items: [ 'Image', 'Table', 'HorizontalRule' ] },
                { name: 'styles', items: [ 'Styles' ] },
                { name: 'colors', items: [ 'TextColor', 'BGColor' ] },
                { name: 'tools', items: [ 'Maximize' ] }
                ],
            }
        }
    },
    computed: {
        ...mapGetters([
            'allActiveUsers',
            'socialSeriesDetail',
        ]),

        getOptions() {
            if (this.customField) {
                if (this.customField.value_set) {
                    let parsed = this.parseValue(this.customField.value_set);
                    if (parsed == false) {
                        return [];  // if we don't check for false... it thows up errors
                    } else {
                        // build value and text
                        return parsed;
                    }
                }
            }
            return [];
        },
    },
    methods: {
        ...mapActions([
            'updateSocialSeriesFieldValue',
            'changeSocialSeriesEngagementManager',
            'changeSocialSeriesLead',
        ]),
        updateCustomField(field) {
            console.log(field);
            field.social_series_id = this.socialSeriesDetail.id;
            this.updateSocialSeriesFieldValue(field);
        },
        checkChangedFieldValue(customField) {
            if (this.changed) {
                this.changed = false;
                this.updateSocialSeriesFieldValue(customField);
            }
        },
        updateColor() {
            this.customField.value = this.color.hex;
            this.updateCustomField(this.customField);
            // this.editing = false;
            // console.log(this.editing);
        },
        showField() {
        	if (this.customField.field_type == "color_picker") {
        		return false;
        	}
        	return true;
        },
        getClasses() {
          let cl = "exclude-outside-click cursor-pointer field-container";
            if (this.customField) {
              if(this.customField.field_key) {
                return "exclude-outside-click cursor-pointer field-container--" + this.customField.field_key;
              }
            }
            return cl;
        },
        activateField() {
            if (this.editing && this.customField.field_type == 'color_picker' && !$(".vc-input__input").is(':focus')) {
                this.editing = false;
                return;
            }
            if (this.editing && this.customField.field_type == 'status') {
                this.editing = false;
                return;
            }
            this.editing = true;
            this.$nextTick(() => {
                if (typeof this.$refs.customInput != "undefined") {
                if(this.customField.field_type == 'wysiwyg') {
                } else {
                    if (typeof this.$refs.customInput.quill != "undefined") {
                    this.$refs.customInput.quill.focus();
                    } else if (typeof this.$refs.customInput.$el != "undefined") {
                    this.$refs.customInput.$el.focus();
                    } else {
                    this.$refs.customInput.focus();
                    }
                }
                } else if(typeof this.$refs.customDatepicker != "undefined") {
                // this.$refs.customDatepicker.$children[0].$emit('showCalendar')
                if(!this.dateSelected) {
                    this.$refs.customDatepicker.showCalendar()
                    this.$refs.customDatepicker.$el.querySelector('input').focus()
                } else if(this.dateSelected) {
                    this.dateSelected = false
                    this.editing = false
                }

                }
            });
        },
        outside() {
            this.editing = false;
        },

        showEngagementManager() {
            this.editing = true;
            this.$nextTick(() => {
                this.$refs.engagementManager.$el.focus();
            });
        },
        showProjectLead() {
            this.editing = true;
            this.$nextTick(() => {
                this.$refs.projectLead.$el.focus();
            });
        },

        changeEngagementManager() {
            this.changeSocialSeriesEngagementManager({engagement_manager: this.engagementManager, id: this.socialSeriesDetail.id, social_series_id: this.socialSeriesDetail.id});
        },
        changeProjectLead() {
            this.changeSocialSeriesLead({project_lead: this.projectLead, id: this.socialSeriesDetail.id, social_series_id: this.socialSeriesDetail.id});
        },

        parseValue(str) {
            try {
                return JSON.parse(str);
            } catch (e) {
                return false;
            }
        },

        customLabel({ name }) {
          return name
        },

        formatPrice(value) {
            const rangeArray = value.split(/(\-|to)/g);

            if (rangeArray.length > 1) {
            for (let i in rangeArray) {
                rangeArray[i] = rangeArray[i].replaceAll(/\$/g, "");
                rangeArray[i] = rangeArray[i].trim();
            }

            let val1 = (rangeArray[0]/1).toFixed(2);
            let val2 = typeof rangeArray[1] == 'number' ? (rangeArray[1]/1).toFixed(2) : (rangeArray[2]/1).toFixed(2);

            if (isNaN(val1) || isNaN(val2)) {
                return "0.00";
            }

            return val1.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " - $" + val2.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
            let valString = value.replaceAll(/\$/g, "");
            valString = valString.trim()
            let val = (valString/1).toFixed(2);

            if (isNaN(val)) return "0.00";

            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
        },
    },
    mounted() {
        if(this.customField.field_type == 'color_picker') {
            let that = this;
            that.color = that.customField.value ? that.customField.value : '#000'
        }
        if(this.customField.field_name == 'project_lead') {
            this.projectLead = this.detail.project_lead;
        }
        if(this.customField.field_name == 'engagement_manager') {
            this.engagementManager = this.detail.engagement_manager;
        }
    },
}
</script>

<style scoped>
.field-container--social_series_detail .field-label {
	margin-bottom:14px;
}
</style>